let xmlRequest = `
<?xml version="1.0" encoding="utf-8"?>
<request>
    <warehouseCode>仓库编码, string (50), 必填</warehouseCode>
    <ownerCode>货主编码, string (50), 必填</ownerCode>
    <orderCode>单据编码, string (50), 必填</orderCode>
    <orderId>仓储系统单据编码,  string (50)</orderId>
    <orderType>单据类型, string (50), 例如: CGRK=采购入库、DBRK=调拨入库、THRK=退货入库、QTRK=其他入库、XSDD=销售订单、DBCK=调拨出库、THCK=退货出库、QTCK=其他出库, 必填</orderType>
    <cancelReason>取消原因, string (500)</cancelReason>
    <cancelType>取消类型, string (500), 例如: in=入库单、out=出库单、sale=销售订单、transport=运单</cancelType>
</request>
`

let xmlResponse = `
<?xml version="1.0" encoding="utf-8"?>
<response>
    <flag>success|failure</flag>
    <code>响应码</code>
    <message>响应信息</message>
</response>
`

export default { xmlRequest, xmlResponse }



// WEBPACK FOOTER //
// ./src/data/openapi/openapi.order.cancel.js